<div class="nav-top">
  <a (click)="redirect()" id="redirect-btn">
    <img src="assets/icons/arrow-left-keyboard.png" class="arrow" alt="arrow blanc">
  </a>
  <p class="title">{{title}}</p>
</div>
